<script setup lang="ts">
usePageViewTracking()

// KeepAlive must wrap every route: per-page meta drops the wrapper on PDP
// and destroys the cached list instead of deactivating it.
const HYBRID_LIST_KEEPALIVE_PAGES = [
  'HybridSearchPage',
  'HybridSearchStagingPage',
  'CategoryPage',
  'SupplierPage',
  'ClinicChainPage',
]

// Gate KeepAlive on the hybrid flag: stateful back-nav (SHP-3630) is hybrid-only, legacy keeps its refetch-on-back behavior.
const isHybridSearch = useIsHybridSearch()
const keepaliveInclude = computed(() =>
  isHybridSearch.value ? HYBRID_LIST_KEEPALIVE_PAGES : [],
)
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <NuxtPage :keepalive="{ include: keepaliveInclude, max: 1 }" />
  </NuxtLayout>
</template>

<style lang="scss">
@use '@/assets/style/global.scss';
</style>
